module.exports = __webpack_public_path__ + "static/media/headset.6375ad71.svg";